// extracted by mini-css-extract-plugin
export var label = "_jg-2";
export var slideContainer = "_jg-0";
export var slider = "_jg-1";